import React, { useState } from 'react'
import Input from '../../../../components/Form/Input'
import Select from '../../../../components/Form/Select'
import TextAreaEditor from '../../../../components/Form/TextAreaEditor'
import { BiMoney } from 'react-icons/bi'
import ButtonHoverAnimated from "../../../../components/Buttons/ButtonHoverAnimated"
import ImagePicker from '../../../../components/ImagePicker'
import DropdownCheckbox from "../../../../components/Dropdown/DropdownCheckbox"
import axios from 'axios'
import {JOB_API_END_POINT as api} from "../../../../utils/constant"
import { useSelector } from 'react-redux'
import Notification from '../../../../components/Notification'

const PostJob = () => {
  const [formValues, setFormValues] = useState({
    recruiter_id: '', // Ajouter l'ID du recruteur si nécessaire
    job_title: '', // "titre" devient "job_title"
    contract_type: '', // "typeEmploi" devient "contract_type"
    salaryType:"A préciser",
    working_method: '', // "modeTravail" devient "working_method"
    category: '', 
    image: null, 
    address: '', 
    // region: '', 
    // district: '', 
    required_profile: '', // "niveauDiplome" devient "required_profile"
    required_skills: [], // "competenceRequise" devient un tableau de compétences
    salary: 0, // Gardé tel quel pour "salaire"
    duration: '', // "montantSalaire" ou équivalent devient "duration"
    description: '', // Gardé tel quel pour "description"
    mission: '', // "responsabilite" devient "mission"
    advantage: '', // Si "benefit" doit être enregistré, sinon supprimez
    staff_number_needed: 0, // Ajouter ce champ requis
    reference: '', // Si nécessaire pour "reference"
    appli_start_at: '', // Date de début des candidatures
    appli_end_at: new Date("dd-MM-YYYY").getDay(), // "dateExpiration" devient "appli_end_at"
    work_start_at: '', // Ajouté pour correspondre à la validation
    work_end_at: '' // Ajouté pour correspondre à la validation
  });
  const {user} = useSelector((state)=>state.user)
  const [errors, setErrors] = useState({});
  const [touchedFields, setTouchedFields] = useState({});
  const [showNotif, setShowNotif] = useState({
    show: false,
    message:"Une erreur est survenue",
    variant: "danger"
  })
  

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormValues((prevValues) => ({ ...prevValues, [name]: value }))
    if (value.trim() !== "") {
      setErrors({
        ...errors,
        [name]: "",
      });
    }
  }

  const validateForm = () => {
    let newErrors = {};

    if (!formValues.job_title.trim()) newErrors.job_title = "Le titre de l'offre est requis.";
    if (!formValues.contract_type) newErrors.contract_type = "Veuillez sélectionner un type d'emploi.";
    if (!formValues.working_method) newErrors.working_method = "Veuillez sélectionner un mode de travail.";
    if (!formValues.category) newErrors.category = "Veuillez sélectionner une catégorie.";
    if (!formValues.appli_end_at) newErrors.appli_end_at = "Veuillez sélectionner une date d'expiration.";
    if (!formValues.address.trim()) newErrors.address = "L'adresse est requise.";
    // if (!formValues.region) newErrors.region = "Veuillez sélectionner une région.";
    // if (!formValues.district) newErrors.district = "Veuillez sélectionner un district.";
    if (!formValues.required_profile) newErrors.required_profile = "Veuillez spécifier le niveau de diplôme.";
    if (!formValues.required_skills.length) newErrors.required_skills = "Veuillez sélectionner au moins une compétence.";
    
    if (formValues.salaryType === "A préciser" && formValues.salary <= 0) {
      newErrors.salary = "Le salaire doit être supérieur à 0.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // const handleImageChange = (image) => {
  //   setFormValues((prevValues) => ({ ...prevValues, image }))
  // }

  const handleImageChange = (event) => {
    const file = event.target.files[0]; // Récupérer le fichier
    if (file) {
        setFormValues((prevValues) => ({ ...prevValues, image: file }));
    }
};

const formatDateForMySQL = (date) => {
  if (!date) return null; 
  return new Date(date).toISOString().slice(0, 19).replace("T", " ");
};

  const handleSubmit = async () => {
    console.log("validate", validateForm());
    if (validateForm()) {
    const formData = new FormData();
  
    // Ajouter chaque champ à FormData
    Object.entries({
      ...formValues,
      required_skills: Array.isArray(formValues.required_skills)
        ? formValues.required_skills
        : formValues.required_skills.split(','), // Convertir en tableau si nécessaire
      recruiter_id: user?.id,
      appli_end_at: formatDateForMySQL(formValues.appli_end_at), // Assurer une date valide
      appli_start_at: new Date().toISOString() // Mettre la date actuelle par défaut
    }).forEach(([key, value]) => {
      if (value instanceof File || value instanceof Blob) {
        formData.append(key, value); // Ajouter l'image ou fichier directement
      } else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          formData.append(`${key}[${index}]`, item); // Ajouter les tableaux comme clés indexées
        });
      } else {
        formData.append(key, value);
      }
    });

    formData.forEach((el, index)=>console.log("Données saisie : ",el,index))
    console.log("Form for posting post", formValues);
  

       await axios.post(api + '/save', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((response)=>{
        console.log(response.data);
        setShowNotif({...showNotif, variant: "success", message:response?.data?.message, show: true})
      })
      .catch( (error)=>{
        setShowNotif({...showNotif, variant: "danger", message:"Une erreur est survenue", show: true})
      console.error("Erreur lors de la soumission :", error);
    })

  }
  };

  // Gestion du focus
  const handleFocus = (e) => {
    const { name } = e.target;
    setTouchedFields({
      ...touchedFields,
      [name]: true,
    });
  };

  // Gestion du blur
  const handleBlur = (e) => {
    const { name, value } = e.target;

    if (touchedFields[name] && value.trim() === "") {
      setErrors({
        ...errors,
        [name]: "Ce champ est requis.",
      });
    }
  };
  

  return (
    <div className='min-h-full w-full pr-6 lg:pr-20 xl:pr-40 pl-6 text-primary-black py-6'>
        <div className="flex justify-between items-center mb-4">
            <h1 className='font-semibold'>Poster une offre</h1>
            <ButtonHoverAnimated onClick={handleSubmit} className='border bg-neutral-200 text-sm rounded-md px-6 py-2 text-white'>
              Publier
            </ButtonHoverAnimated>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
      <Input label="Titre de l'offre" name="job_title" value={formValues.job_title} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.job_title} />
      <Select label="Type d'emploi" name="contract_type" options={["CDI", "CDD"]} value={formValues.contract_type} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.contract_type} />
      <Select label="Mode de travail" name="working_method" options={["Présentiel", "Télétravail"]} value={formValues.working_method} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.working_method} />
      <Input label="Durée" name="duration" value={formValues.duration} onChange={handleChange} />
      <Select label="Catégorie" name="category" options={["Informatique", "Marketing"]} value={formValues.category} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.category} />
      <Input label="Date d'expiration" name="appli_end_at" type="date" value={formValues.appli_end_at} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.appli_end_at} />
      <ImagePicker label="Image" handleImage={handleImageChange} initialImage={formValues.image} />

      

      <h3 className="font-semibold text-start mb-4">Critères de sélection</h3>
      <div className="grid grid-cols-3 gap-4">
        <Input label="Niveau de diplôme" name="required_profile" value={formValues.required_profile} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.required_profile} />
        <DropdownCheckbox label='Compétence réquise' className="col-span-2" setValuesSelected={(value) => setFormValues({ ...formValues, required_skills: value })} />
      </div>

      <h3 className="font-semibold text-start mb-4">Salaire</h3>
      <div className="grid grid-cols-3 gap-4 items-center">
        {["A préciser", "A négocier", "Aucun"].map((option) => (
          <label key={option} className="bg-neutral-50 border rounded-md p-2 gap-2 flex items-center">
            <input type="radio" name="salaryType" value={option} checked={formValues.salaryType === option} onChange={handleChange} className="w-4 h-4" />
            <div className="flex flex-col justify-center space-y-2">
              <p>{option}</p>
            </div>
          </label>
        ))}
      </div>

      {formValues.salaryType === "A préciser" && (
        <Input type="number" label="Salaire à payer (en Ariary)" name="salary" value={formValues.salary} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.salary} />
      )}

      <TextAreaEditor label="Description" value={formValues.description} setValue={(value) => setFormValues({ ...formValues, description: value })} />
      <TextAreaEditor label="Responsabilité" value={formValues.mission} setValue={(value) => setFormValues({ ...formValues, mission: value })} />
      <TextAreaEditor label="Avantage" value={formValues.benefit} setValue={(value) => setFormValues({ ...formValues, benefit: value })} />

      <h3 className="font-semibold text-start mb-4">Localisation</h3>
      <div className="grid gap-4">
        <Input label="Adresse" name="address" value={formValues.address} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.address} />
        {/* <Select label="Région" name="region" options={["Antananarivo", "Fianarantsoa"]} value={formValues.region} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.region} />
        <Select label="District" name="district" options={["Ambohidratrimo", "Antsirabe"]} value={formValues.district} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.district} /> */}
      </div>

      {/* <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded-md">Soumettre</button> */}
    </form>
        {/* <div className='space-y-4'>
            <Input label="Titre de l'offre" name="job_title" value={formValues.job_title} onChange={handleChange} />
            <Select label="Type d'emploi" name="contract_type" placeholder='Veuillez sélectionner' options={["CDI", "CDD"]} value={formValues.contract_type} onChange={handleChange} />
            <Select label="Mode de travail" name="working_method" placeholder='Veuillez sélectionner' options={["Présentiel", "Télétravail"]} value={formValues.working_method} onChange={handleChange} />
            <Input label="Durée" name="duration" placeholder='2 ans' value={formValues.duration} onChange={handleChange} />
            <Select label="Catégorie" name="categorie" placeholder='Veuillez sélectionner' options={["Informatique", "Marketing"]} value={formValues.categorie} onChange={handleChange} />
            <Input label="Date d'éxpiration" name="appli_end_at" type='date' value={formValues.appli_end_at} onChange={handleChange} />
            <ImagePicker label='Image' handleImage={handleImageChange} initialImage={formValues.image} />

            <h3 className='font-semibold text-start mb-4'>Localisation</h3>
            <div className="grid grid-cols-3 gap-4">
              <Input label="Adresse" name="address" value={formValues.address} onChange={handleChange} />
              <Select label="Région" name="region" placeholder='Veuillez sélectionner' options={["Antananarivo", "Fianarantsoa"]} value={formValues.region} onChange={handleChange} />
              <Select label="District" name="district" placeholder='Veuillez sélectionner' options={["Ambohidratrimo", "Antsirabe"]} value={formValues.district} onChange={handleChange} />
            </div>

            <h3 className='font-semibold text-start mb-4'>Critère de sélection</h3>
            <div className="grid grid-cols-3 gap-4">
              <Input label="Niveau de diplôme" name="required_profile" value={formValues.required_profile} onChange={handleChange} />
              <Select label="Compétence réquise" name="required_skills" placeholder='Veuillez sélectionner' options={["JavaScript", "React"]} value={formValues.required_skills} onChange={handleChange} />
              <Select label="Niveau professionnel" name="niveauPro" placeholder='Veuillez sélectionner' options={["Tout public", "Junior", "Intermédiaire", "Confirmé"]} value={formValues.niveauPro} onChange={handleChange} />
            </div>
            <DropdownCheckbox setValuesSelected={(value)=>{setFormValues({ ...formValues, required_skills : value })}}/>

            <h3 className='font-semibold text-start mb-4'>Salaire</h3>
            <div className="grid grid-cols-3 gap-4 items-center">
              <label className="bg-neutral-50 border rounded-md p-2 gap-2 flex items-center">
                <input type="radio" name="salaryType" value="A préciser" checked={formValues.salaryType === "A préciser"} onChange={handleChange} className='w-4 h-4' />
                <div className="flex flex-col justify-center space-y-2">
                  <p>Préciser</p>
                </div>
              </label>
              <label className="bg-neutral-50 border rounded-md p-2 gap-2 flex items-center">
                <input type="radio" name="salaryType" value="A négocier" checked={formValues.salaryType === "A négocier"} onChange={handleChange} className='w-4 h-4' />
                <div className="flex flex-col justify-center space-y-2">
                  <p>A négocier</p>
                </div>
              </label>
              <label className="bg-neutral-50 border rounded-md p-2 gap-2 flex items-center">
                <input type="radio" name="salaryType" value="Aucun" checked={formValues.salaryType === "Aucun"} onChange={handleChange} className='w-4 h-4' />
                <div className="flex flex-col justify-center space-y-2">
                  <p>Aucun</p>
                </div>
              </label>
            </div>
            {
              formValues.salaryType  === "A préciser" &&
              <div className="grid grid-cols-2 gap-4">
              <Input type='number' label="Salaire à payer (en Ariary)" name="salary" value={formValues.salary} onChange={handleChange} />              
            </div>
            }
           
            <TextAreaEditor label='Description' value={formValues.description} setValue={(value) => setFormValues((prevValues) => ({ ...prevValues, description: value }))} />
            <TextAreaEditor label='Responsabilité' value={formValues.mission} setValue={(value) => setFormValues((prevValues) => ({ ...prevValues, mission: value }))} />
            <TextAreaEditor label='Avantage' value={formValues.benefit} setValue={(value) => setFormValues((prevValues) => ({ ...prevValues, benefit: value }))} />
        </div> */}
        <Notification variant={showNotif.variant} text={showNotif.message} isOpen={showNotif.show} setIsOpen={()=>setShowNotif({...showNotif, show: false})} />
    </div>
  )
}

export default PostJob
